<template>
  <v-row align="center" dense>
    <v-col cols="12" sm="6" md="3">
      <!--
        A tarifa é o tipo da linha. Só aparecem as ainda não usadas neste tipo
        de veículo: é a primeira das três barreiras contra tarifa repetida.
      -->
      <v-autocomplete
        :value="value.id_tarifa"
        :items="tarifasDisponiveis"
        :label="$t('contractV2.row.tariff')"
        item-value="id_tarifa"
        item-text="descricao_tarifa"
        :search-input.sync="buscaTarifa"
        :rules="readonly ? [] : [(v) => !!v || $t('contractV2.row.tariffRequired')]"
        :disabled="readonly"
        @change="atualiza('id_tarifa', $event)"
      >
        <template v-slot:no-data>
          <v-list-item v-if="canCriarTarifa && buscaTarifa" @click="$emit('criar-tarifa', buscaTarifa)">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('contractV2.newTariff.createNamed', { name: buscaTarifa }) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-content>
              <v-list-item-title>{{ $t('contractV2.row.noTariff') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:append-item>
          <v-divider v-if="canCriarTarifa" class="mb-1"></v-divider>
          <v-list-item v-if="canCriarTarifa" @click="$emit('criar-tarifa', buscaTarifa || '')">
            <v-list-item-icon class="mr-2">
              <v-icon small color="primary">mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('contractV2.newTariff.title') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="2">
      <v-text-field
        :value="value.valor"
        :label="$t('contractV2.row.value')"
        :prefix="$t('contract.currencyCipher') + ' '"
        type="number"
        min="0"
        step="any"
        hide-spin-buttons
        :rules="readonly ? [] : [(v) => v == null || v === '' || Number(v) >= 0 || $t('contractV2.row.nonNegative')]"
        :clearable="!readonly"
        :disabled="readonly"
        @input="atualiza('valor', $event)"
      ></v-text-field>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <!-- A métrica sobre a qual o valor incide: um cálculo de grandeza. -->
      <v-autocomplete
        :value="value.id_calculo_grandeza"
        :items="grandezas"
        :label="$t('contractV2.row.magnitude')"
        item-value="id_calculo"
        :item-text="calculoLabel"
        :rules="readonly ? [] : [(v) => !!v || $t('contractV2.row.magnitudeRequired')]"
        :hint="$t('contractV2.row.magnitudeHint')"
        persistent-hint
        :disabled="readonly"
        @change="atualiza('id_calculo_grandeza', $event)"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <!-- Restringe a grandeza. Um só por linha. -->
      <v-autocomplete
        :value="value.id_calculo_filtro"
        :items="calculos"
        :label="$t('contractV2.row.filter')"
        item-value="id_calculo"
        :item-text="calculoLabel"
        :hint="$t('contractV2.row.filterHint')"
        persistent-hint
        clearable
        :disabled="readonly"
        @change="atualiza('id_calculo_filtro', $event)"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="1" class="text-right">
      <v-icon v-if="!readonly" small color="red" @click="$emit('remove')">mdi-delete</v-icon>
    </v-col>
  </v-row>
</template>

<script>
/**
 * Uma linha de valor do contrato: `valor × grandeza`, opcionalmente restrita
 * por um filtro. O componente não muta `value` — emite a linha inteira, para
 * que o pai continue dono do array (Vue 2 não observa índices).
 */
export default {
  name: 'ContratoValorLinha',
  props: {
    value: { type: Object, required: true },
    tarifasDisponiveis: { type: Array, default: () => [] },
    // Cálculos de finalidade GRANDEZA (ver aceitaComoGrandezaLinha).
    grandezas: { type: Array, default: () => [] },
    calculos: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    canCriarTarifa: { type: Boolean, default: false },
  },
  data: () => ({
    buscaTarifa: null,
  }),
  methods: {
    atualiza(campo, valor) {
      const linha = Object.assign({}, this.value);
      if (campo === 'valor') {
        linha.valor = valor === '' || valor == null ? null : Number(valor);
      } else {
        linha[campo] = valor == null ? null : valor;
      }
      this.$emit('input', linha);
    },
    calculoLabel(calculo) {
      if (!calculo) return '';
      return calculo.descricao ? calculo.descricao : calculo.codigo;
    },
  },
};
</script>
